<div class="content__container">
    <!-- BONUS -->
    @if (data()?.bonus?.length) {
    <div class="bonus">
        <div class="bonus__wrap">
            @for (item of data()?.bonus; track $index) {
            <div class="item">
                <div class="item__wrap-icon">
                    <img [src]="'assets/icons/package-detail-icons/' + item.class + '.svg'" alt="" class="icon">
                    <div class="name">{{item.name}}</div>
                </div>
                <div class="item__quota">{{item.quota}}</div>
            </div>
            }
        </div>
    </div>
    }

    <!-- DESCRIPTION -->
     <!-- invalid BEM naming convention -->
    <div class="wrap__desc__terms">
        @if(data()?.longdesc) {
        <div class="description">
            <div class="header__description">
                <div class="label">{{'packageDetail.description' | translate}}</div>
                <button type="button" class="accordion-btn" (click)="onClickAccordion('description')" [ngClass]="isShowDesc ? 'rotate-180 ' : ' rotate-0 '" tabindex="0">
                    <img src="assets/icons/accordion-down.svg" alt="accordion-icon">
                </button>
            </div>
            <div [ngClass]="isShowDesc ? 'h-auto' : 'h-0 '" class="value duration-500 transition-[height] ease-in-out"
                [innerHTML]="data()?.longdesc | safe:'html'"></div>
        </div>
        }
        <!-- TERMS -->
        @if(data()?.terms) {
        <div class="terms">
            <div class="header__terms">
                <div class="label">{{'packageDetail.terms' | translate}}</div>
                <button type="button" class="accordion-btn" (click)="onClickAccordion('terms')" [ngClass]="isShowTerms ? 'rotate-180 ' : ' rotate-0 '" tabindex="0">
                    <img src="assets/icons/accordion-down.svg" alt="accordion-icon">
                </button>
            </div>
            <div [ngClass]="isShowTerms ? 'h-auto' : 'h-0 '" class="value duration-500 transition-[height] ease-in-out"
                [innerHTML]="data()?.terms | safe:'html'"></div>
        </div>
        }
    </div>
</div>
